import React from 'react';

import { Control, Controller } from 'react-hook-form';

import { Box, Button, Stack } from '@mui/material';

import { FinePrintItem } from '~/types/tours/tourOffer';

import FinePrintEditor from '../Bundles/FinePrintEditor';

import NativeTourCard from './NativeTourCard';
import { NativeTourForm } from './nativeTourForm';

interface Props {
  control: Control<NativeTourForm>;
  /** The brand's default, offered while the tour has none. */
  defaultFinePrint: Array<FinePrintItem> | undefined;
}

export default function NativeTourFinePrintSection({ control, defaultFinePrint }: Props) {
  return (
    <NativeTourCard
      title="Fine print"
      description="What's not included, important information and the rest of the fine print on the page."
    >
      <Controller
        control={control}
        name="content.finePrint"
        render={({ field }) => (
          <Stack spacing={2}>
            {field.value.length === 0 && defaultFinePrint && defaultFinePrint.length > 0 && (
              <Box>
                <Button variant="contained" onClick={() => field.onChange(defaultFinePrint)}>
                  Start from the brand's default fine print
                </Button>
              </Box>
            )}
            <FinePrintEditor items={field.value} onChange={field.onChange} />
          </Stack>
        )}
      />
    </NativeTourCard>
  );
}
